<template>
  <div class="card shadow" style="position: relative">
    <div id="printable-client-bill" v-show="printing">
      <CaisseBill :items="data" :total="total" :numero="number" ref="caisse" />
    </div>
    <div id="myElement"></div>
    <GStockLoader :loading="loading" />
    <div class="card-header border-0">
      <div class="col-6">
        <b>Au profit de Mr/Mme {{ client.fullname }}</b
        ><br /><br /><br /><br /><br />
        <div style="font-size: 20px">
          <b>Total : {{ total }}</b>
        </div>
        <div style="font-size: 20px; margin-top: 10px">
          <span>Remise</span>
          <br /><br /><input type="number" v-model="remise" placeholder="0 %" />
          %
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col text-right">
          <b-dropdown
            id="dropdown-1"
            :text="selectedPaymentMethod"
            class="m-md-2"
          >
            <b-dropdown-item @click="selectedPaymentMethod = 'ESPECE'"
              >ESPECE</b-dropdown-item
            >
            <b-dropdown-item @click="selectedPaymentMethod = 'CREDIT'"
              >CREDIT</b-dropdown-item
            >
            <b-dropdown-item @click="selectedPaymentMethod = 'CHEQUE'"
              >CHEQUE</b-dropdown-item
            >
          </b-dropdown>
          <base-button
            style="
              background-color: #000;
              width: 150px;
              height: 50px;
              color: #fff;
            "
            size="sm"
            @click="findProduct"
            >Ajouter</base-button
          >
          <base-button
            style="
              background-color: green;
              width: 150px;
              height: 50px;
              color: #fff;
            "
            size="sm"
            @click="createDelivery"
            >Valider et imprimer</base-button
          >
        </div>
      </div>
    </div>

    <base-table
      striped
      class="table striped align-items-center"
      tbody-classes="list"
      :data="items"
    >
      <template slot="columns">
        <th>Réf</th>
        <th>Article</th>
        <th>Prix</th>
        <th>Prix en main</th>
        <th>Status</th>
        <th>Déposant</th>
        <th>Date de dépot</th>
        <th></th>
        <th></th>
      </template>

      <template slot-scope="{ row }">
        <td class="budget" style="cursor: pointer">
          {{ row.id }}
        </td>
        <td style="cursor: pointer">
          {{ row.name }}
        </td>

        <td style="cursor: pointer">{{ row.price }} DT</td>
        <td style="cursor: pointer">
          {{ (row.price * (1 - row.percentage)).toFixed(2) }} DT
        </td>

        <td style="cursor: pointer">
          {{
            row.canceled
              ? "Annulé"
              : row.purchased == 1
              ? "Vendu"
              : "Disponible"
          }}
        </td>
        <td style="cursor: pointer">
          {{ row.client.name }}
        </td>
        <td style="cursor: pointer">
          {{ $options.filters.date(row.createdOn) }}
        </td>
        <td class="text-right">
          <div
            @click="showConfirm(row.id)"
            style="font-size: 25px; cursor: pointer; color: red"
          >
            <b-icon icon="trash"></b-icon>
          </div>
        </td>
      </template>
    </base-table>
    <b-modal id="modal-delete" hide-footer title="Sypprimer produit">
      <p class="my-4">Voulez vous supprimer</p>
      <hr class="my-4" />
      <center>
        <b-btn type="submit" style="background-color: #c2b59b; color: #fff"
          >non</b-btn
        >
        <b-btn type="submit" style="background-color: #c2b59b; color: #fff"
          >oui</b-btn
        >
      </center>
    </b-modal>
    <SearchProduct ref="lookForProduct" isLookup />
    <img
      :src="imgSrc"
      v-show="false"
      width="310px"
      height="142px"
      id="printable"
    />
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import { post, get, del, put } from "@/mixins/api";
import printJS from "print-js";
import { EventBus } from "@/events/event-bus";
import GStockLoader from "@/components/Loader";
import SearchProduct from "../Produit/SearchProduct";
import DeliveryBill from "@/components/DeliveryBill";
import CaisseBill from "@/components/CaisseBillV2";
import html2canvas from "html2canvas";

export default {
  name: "ClientTable",
  components: {
    SearchProduct,
    GStockLoader,
    DeliveryBill,
    CaisseBill,
  },
  props: {
    canceled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      values: [],
      currentPage: 1,
      perPage: 20,
      canLoadMore: true,
      category: 0,
      loadedProducts: {},
      currentProduct: { photos: [] },
      canGoNext: true,
      data: [],
      search: "",
      prefix: "products",
      current: 0,
      imgSrc: "",
      currentProduct: {},
      admin: false,
      statsByOwner: {},
      loading: false,
      clientId: null,
      client: {},
      printing: false,
      remise: 0,
      selectedPaymentMethod: "ESPECE",
      number: 0,
    };
  },
  computed: {
    items() {
      return this.data;
    },
    total() {
      const total = this.items.reduce((acc, it) => (acc += it.price), 0);
      const toSoustract = this.remise >= 0 ? total * (this.remise / 100) : 0;
      return (total - toSoustract).toFixed(2);
    },
  },
  methods: {
    buyProduct(products) {
      const payload = {
        client: this.clientId,
        products,
        total: this.total,
        selectedPaymentMethod: this.selectedPaymentMethod,
      };
      post("delivery", payload).then((res) => {
        this.number = res.data.data.number;
        setTimeout(() => {
          this.data = [];
          this.makeToast("Produits vendus", "success");
          this.$refs.caisse.printMe();
        }, 1000);
      });
    },
    getDate(date) {
      const dDate = new Date(date);
      const day = dDate.getDate() > 9 ? dDate.getDate() : "0" + dDate.getDate();
      const realMonth = dDate.getMonth() + 1;
      const month = realMonth > 9 ? realMonth : "0" + realMonth;
      const year = dDate.getFullYear();
      return `${day}/${month}/${year}`;
    },
    findProduct() {
      this.$refs.lookForProduct.showModal();
    },
    createDelivery() {
      if (this.data.length == 0) return;
      this.loading = true;
      this.$bvModal
        .msgBoxConfirm(
          "Vous confirmez que vous allez passer cette commande avec un total de " +
            this.total +
            " DT ?",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.buyProduct(this.data.map((x) => x.id));
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      // const delivery = {
      //   products: this.data.map((_) => _.id),
      //   client: this.client.id,
      // };
      // this.loading = true;
      // post("delivery", delivery)
      //   .then((res) => {
      //     this.printing = true;
      //     setTimeout(() => {
      //       printJS({
      //         printable: "printable-client-bill",
      //         type: "html",
      //         header: "",
      //       });
      //       this.printing = false;
      //     }, 500);
      //     this.data = [];
      //     this.makeToast(
      //       "Votre livraison est bien effectuée sous le code : " +
      //         res.data.data.deliverycode,
      //       "success"
      //     );
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    print() {
      const canvas = document.getElementById("bar-code-" + this.current);
      this.imgSrc = canvas.toDataURL("image/png");
      printJS({
        printable: this.imgSrc,
        type: "image",
        header: "",
      });
    },
    showConfirm(id) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Vous confirmez que vous allez supprimer cet article ?",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            const index = this.data.findIndex((_) => _.id == id);
            if (index >= 0) {
              this.data.splice(index, 1);
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    addProduct(product) {
      if (!this.data.some((pr) => pr.id == product.id)) this.data.push(product);
      setTimeout(() => {
        this.findProduct();
      }, 500);
    },
    makeToast(msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: "Ajout produit.",
        variant: variant ? variant : "danger",
        solid: true,
      });
    },
  },
  filters: {
    date: function (value) {
      if (!value) return "";
      const date = new Date(value);
      const tmp = date.toLocaleDateString("fr-FR", { weekday: "long" });
      const day = tmp.charAt(0).toUpperCase() + tmp.slice(1);
      const month = date.toLocaleString("fr-FR", { month: "long" });
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      let currentHour = date.getHours() + "";
      let currentMinute = date.getMinutes() + "";
      if (currentHour.length < 2) currentHour = "0" + currentHour;
      if (currentMinute.length < 2) currentMinute = "0" + currentMinute;
      return (
        day +
        " " +
        dayOfMonth +
        " " +
        month +
        " " +
        year +
        ", " +
        currentHour +
        ":" +
        currentMinute
      );
    },
  },
  mounted() {
    const id = this.$route.params.id;
    this.clientId = id;
    this.loading = true;
    get("client/" + id).then((response) => {
      this.client = response.data.data;
      this.loading = false;
    });
  },
};
</script>
<style lang="scss">
#printable-client-bill {
  width: 100vw;
  height: 100vh;
}
td,
th {
  //   max-width: min-content;
  //   padding: 0.75em !important;
  //   @media (max-width: 1474px) {
  //     padding: 0.5em !important;
  //   }
  //   @media (max-width: 1394px) {
  //     padding: 0.3em !important;
  //   }
}
.btn-primary {
  background-color: #000;
  border-color: #000;
}
.page-item {
  &.active {
    .page-link {
      background-color: #000;
      border-color: #000;
    }
  }
}
</style>
